$(document).ready(function(){

  $('.container-buttons #inches').click(function() {
    $('.chart-buttons .container-buttons button').removeClass("active-button");
    $('.size-chart__columns-rows p span').hide();
    $(this).addClass('active-button');
    $('.size-chart__columns-rows p span.size-inches').show();
  });

  $('.container-buttons #centimeters').click(function() {
    $('.chart-buttons .container-buttons button').removeClass("active-button");
    $('.size-chart__columns-rows p span').hide();
    $(this).addClass('active-button');
    $('.size-chart__columns-rows p span.size-cm').show();
  });

  

  $('.size-guide-chart-modal > li > .description-product__answer').hide();
  $('.size-guide-chart-modal > li.active_description > .description-product__answer').show();
  
  $('.size-guide-chart-modal > li > h3').click(function() {
    var $open_description = $(this).parents('li');
    if ($($open_description).hasClass("active_description")) {
      $($open_description).removeClass("active_description").find(".description-product__answer").slideUp();
    } else {
      $(".size-guide-chart-modal > li.active_description .description-product__answer").slideUp();
      $(".size-guide-chart-modal > li.active_description").removeClass("active_description");
      $($open_description).addClass("active_description").find(".description-product__answer").slideDown();
    }
    return false;
  });
  
});